const ASLangs = [
    // 中文
    { label: "简体中文", value: "zh-CN", fileName: "zh-CN", localeLang: "zh-CN", colIndex: 0 },
    // 英文
    { label: "English", value: "en", fileName: "en", localeLang: "en-US", colIndex: 1 },
]
module.exports = ASLangs